import FpChartHtml from './FpChartHtml.jsx'

export default FpChartHtml
